<template>
    <el-card v-loading="loading">
        <div class="stats-flow">
            <div class="stats-top-select flex items-center justify-between">
                <el-select
                    @change="refreshData"
                    v-model="form.storeId"
                    :placeholder="$t('Common.please_choose')">
                    <el-option
                        v-for="item in stores"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <div class="top-select-time">{{ $t('Week.refresh_time2') }}：{{ updateDate }}</div>
            </div>
            <div class="stats-table-cart flex items-center justify-between" v-if="formData">
                <div class="table-cart-items">
                    <div class="table-cart-title">{{ $t('Stats.Enter.people') }}</div>
                    <div class="table-cart-num">{{ formData.entranceOfToday }}</div>
                    <div class="table-cart-small">
                        <div>{{ $t('Stats.Time.yesterday') }} {{ formData.entranceOfYesterday }}</div>
                        <div>{{ $t('Stats.Time.this_week') }} {{ formData.entranceOfWeek }}</div>
                        <div>{{ $t('Stats.Time.this_month') }} {{ formData.entranceOfMonth }}</div>
                    </div>
                </div>
                <div class="table-cart-items">
                    <div class="table-cart-title">{{ $t('Stats.Enter.personal_sign') }}</div>
                    <div class="table-cart-num">{{ formData.signedCoachScheduleOfToday }}</div>
                    <div class="table-cart-small">
                        <div>{{ $t('Stats.Time.yesterday') }} {{ formData.signedCoachScheduleOfYesterday }}</div>
                        <div>{{ $t('Stats.Time.this_week') }} {{ formData.signedCoachScheduleOfWeek }}</div>
                        <div>{{ $t('Stats.Time.this_month') }} {{ formData.signedCoachScheduleOfMonth }}</div>
                    </div>
                </div>
                <div class="table-cart-items">
                    <div class="table-cart-title">{{ $t('Stats.Enter.team_people') }}</div>
                    <div class="table-cart-num">{{ formData.teamScheduleOfToday }}</div>
                    <div class="table-cart-small">
                        <div>{{ $t('Stats.Time.yesterday') }} {{ formData.teamScheduleOfYesterday }}</div>
                        <div>{{ $t('Stats.Time.this_week') }} {{ formData.teamScheduleOfWeek }}</div>
                        <div>{{ $t('Stats.Time.this_month') }} {{ formData.teamScheduleOfMonth }}</div>
                    </div>
                </div>
                <div class="table-cart-items">
                    <div class="table-cart-title">{{ $t('Stats.Enter.team_appoint') }}</div>
                    <div class="table-cart-num">{{ formData.teamScheduleClientOfToday }}</div>
                    <div class="table-cart-small">
                        <div>{{ $t('Stats.Time.yesterday') }} {{ formData.teamScheduleClientOfYesterday }}</div>
                        <div>{{ $t('Stats.Time.this_week') }} {{ formData.teamScheduleClientOfWeek }}</div>
                        <div>{{ $t('Stats.Time.this_month') }} {{ formData.teamScheduleClientOfMonth }}</div>
                    </div>
                </div>
            </div>
            <div class="choose-date">
                <el-select @change="checkDay" v-model="range">
                    <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-date-picker
                    @change="fetchCharData"
                    v-model="form.charDate"
                    type="daterange"
                    :range-separator="$t('Reception.Third.zhi')"
                    value-format="yyyy-MM-dd"
                    :start-placeholder="$t('Common.start_time')"
                    :end-placeholder="$t('Common.end_time')">
                </el-date-picker>
            </div>
            <div class="flow-chat-list">
                <div class="flex justify-between">
                    <el-radio-group v-model="tabPosition" @change="getChart">
                        <el-radio-button label="number">{{ $t('Reception.First.sign') }}</el-radio-button>
                        <el-radio-button label="trainer">{{ $t('Stats.Enter.person_lesson') }}</el-radio-button>
                        <el-radio-button label="groups">{{ $t('Stats.Enter.team_lesson') }}</el-radio-button>
                    </el-radio-group>
                </div>
                <div v-if="tabPosition === 'number'" class="chart-show" id="flow-charts-number"></div>
                <div v-if="tabPosition === 'trainer'" class="chart-show" id="flow-charts-trainer"></div>
                <div v-if="tabPosition === 'groups'" class="chart-show" id="flow-charts-groups"></div>
            </div>
            <div class="flow-date-btn">
                <el-date-picker
                    v-model="form.pageDate"
                    type="daterange"
                    :range-separator="$t('Reception.Third.zhi')"
                    :start-placeholder="$t('Common.start_time')"
                    :end-placeholder="$t('Common.end_time')"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <el-button
                    @click="fetchPage"
                    type="primary"
                    class="el-button-t">
                    {{ $t('Common.search_cha') }}
                </el-button>
            </div>
            <div class="flow-search">
                <div class="flow-search-title">{{ $t('Charge.search') }}：</div>
                <div class="flow-search-content">
                    {{ $t('Board.Flow.make_of_private') }}{{ pageData.coachScheduleClientTotal }}，
                    {{ $t('Board.Flow.subscribeNumver') }}{{ pageData.coachScheduleTotal }}，
                    {{ $t('Stats.Enter.sign') }}{{ pageData.signedCoachScheduleClientTotal }}，
                    {{ $t('Board.Flow.signinNumber') }}{{ pageData.signedCoachScheduleTotal }}，
                    {{ $t('Board.Flow.coachNumber') }}{{ pageData.signedCoachScheduleCoachTotal }}；
                    {{ $t('Board.Flow.League_of_classnumber') }}{{ pageData.teamScheduleTotal }}，
                    {{ $t('Lesson.appoint_count') }}{{ pageData.teamScheduleClientTotal }}，
                    {{ $t('Stats.Enter.sign') }}{{ pageData.signedTeamScheduleClientTotal }}，
                    {{ $t('Board.Flow.coachNumber') }}{{ pageData.teamScheduleCoachTotal }}，
                    {{ $t('Board.Flow.entrance_people') }}{{ pageData.entranceTotal }}
                </div>
            </div>
            <el-table
                :data="pageData.content"
                style="width: 100%;"
                border>
                <el-table-column prop="date" :label="$t('Common.time')"/>
                <el-table-column prop="storeName" :label="$t('Common.store')"/>
                <el-table-column prop="entrance" :label="$t('Board.Flow.entrance_people')"/>
                <el-table-column label="团课">
                    <el-table-column prop="teamSchedule" :label="$t('Stats.Enter.lesson')"/>
                    <el-table-column prop="teamScheduleClient" :label="$t('Lesson.appoint_count')"/>
                    <el-table-column prop="signedTeamScheduleClient" :label="$t('Stats.Enter.sign')"/>
                    <el-table-column prop="teamScheduleCoach" :label="$t('Board.Flow.coachNumber')"/>
                </el-table-column>
                <el-table-column :label="$t('Board.Flow.Personaltainer')">
                    <el-table-column prop="coachScheduleClient" :label="$t('Lesson.appoint_count')"/>
                    <el-table-column prop="coachSchedule" :label="$t('Board.Flow.subscribeNumver')"/>
                    <el-table-column prop="signedCoachScheduleClient" :label="$t('Stats.Enter.sign')"/>
                    <el-table-column prop="signedCoachSchedule" :label="$t('Board.Flow.signinNumber')"/>
                    <el-table-column prop="signedCoachScheduleCoach" :label="$t('Board.Flow.coachNumber')"/>
                </el-table-column>
            </el-table>
            <div class="page flex justify-end items-right">
                <el-pagination
                    v-if="pageData && pageData.content && pageData.content.length"
                    class="text-right"
                    @current-change="fetchPage"
                    :current-page.sync="form.page"
                    :page-size="pagination.size"
                    layout="total, prev, pager, next, jumper"
                    :total="pagination.total" />
            </div>
        </div>
    </el-card>
</template>
<script>
import echarts from 'echarts';
import { DatePicker, Radio, RadioButton, RadioGroup} from 'element-ui';
import timeMixin from '@/mixins/timeMixin.js';

export default {
    name: 'statsFlow',
    components: {
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
    },
    mixins: [timeMixin],
    data() {
        return {
            tabPosition: 'number',
            stores: [],
            form: {
                storeId: '',
                dateFrom: null,
                dateTo: null,
                page: 1,
                pageDate: [],
                charDate: [],
            },
            loading: false,
            pagination: {
                total: 0,
                size: 10,
            },
            formData: {},
            pageData: {},
            charData: {},
            range: 30,
            options: [
                {
                    label: this.$t('Stats.Time.seven'),
                    id: 7,
                }, {
                    label: this.$t('Stats.Time.half_month'),
                    id: 15,
                }, {
                    label: this.$t('Stats.Time.a_month'),
                    id: 30,
                }, {
                    label: this.$t('Stats.Time.this_week'),
                    id: 'week',
                }, {
                    label: this.$t('Stats.Time.this_month'),
                    id: 'month',
                },
            ],
            updateDate: null,
        };
    },
    created() {
        this.fetchStore();
        this.fetchData();
        this.fetchPage();
        this.checkDay();
        this.fetchDate();
    },
    methods: {
        fetchStore() {
            this.stores = [
                {
                    id: '',
                    name: this.$t('Common.all_store2'),
                },
            ];
            API.get(`store/list`).then(res => {
                res.filter(el => this.stores.push(el));
            });
        },
        fetchData() {
            this.loading = true;
            API.get(`statistic/client-flow/summary`, {
                params: {
                    storeId: this.form.storeId,
                },
            }).then(res => {
                this.formData = res;
            }).finally(() => this.loading = false);
        },
        fetchPage() {
            if (!this.form.pageDate.length) {
                let arr = [];
                arr[0] = arr[1] = new Date().format('YYYY-MM-DD');
                this.form.pageDate = arr;
            }
            const form = Object.assign({}, this.form);
            form.dateFrom = form.pageDate[0];
            form.dateTo = form.pageDate[1];
            delete form.pageDate;
            API.get('statistic/client-flow/pages', {
                params: form
            }).then(res => {
                this.pageData = res;
                this.pagination.total = res.totalElements;
            });
        },
        fetchDate() {
            API.get('statistic/last-update-time?type=1')
            .then(res => {
                this.updateDate = res;
            });
        },
        refreshData() {
            this.form.page = 1;
            this.tabPosition = 'number';
            this.fetchData();
            this.fetchPage();
            this.fetchCharData();
            this.fetchDate();
        },
        async fetchCharData() {
            await API.get(`statistic/client-flow/chart`, {
                params: {
                    dateFrom: this.form.charDate[0],
                    dateTo: this.form.charDate[1],
                    storeId: this.form.storeId,
                },
            }).then(res => {
                this.charData = res;
            });
            this.$nextTick(() => {
                this.getChart();
            });
        },
        checkDay() {
            let start;
            if (this.range === 'week') {
                const week = this.handleWeekly(new Date());
                start = week.startOfWeek;
            } else if (this.range === 'month') {
                start = this.startOfMonth(new Date());
            } else {
                start = this.subDays(new Date(), this.range);
            }
            const end = new Date().format('YYYY-MM-DD');
            let arr = [];
            arr[0] = this.range === 'week' ? start : start.format('YYYY-MM-DD');
            arr[1] = end;
            this.form.charDate = arr;
            this.fetchCharData();
        },
        getChart() {
            if (this.tabPosition === 'number') this.initMemberChart();
            else if (this.tabPosition === 'trainer') this.initTrainerChart();
            else if (this.tabPosition === 'groups') this.initGroupsChart();
        },
        initMemberChart() {
            const chart = document.getElementById('flow-charts-number');
            chart.style.height = '500px';
            chart.style.width = '100%';
            const myChart = echarts.init(chart);
            myChart.clear();
            let totalArr = [];
            totalArr.push(this.$t('Board.Flow.headcount'));
            const option = {
                color: ['#3398DB'],
                legend: {
                    // data: ['总人数'],
                    data: totalArr,
                },
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.charData.map(el => el.date),
                        axisTick: {
                            alignWithLabel: true,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                    },
                ],
                series: [
                    {
                        name: this.$t('Board.Flow.headcount'),
                        type: 'bar',
                        barWidth: '20%',
                        data: this.charData.map(el => el.entrance),
                    },
                ],
            };
            myChart.setOption(option);
        },
        initTrainerChart() {
            const chart = document.getElementById('flow-charts-trainer');
            chart.style.height = '500px';
            chart.style.width = '100%';
            const myChart = echarts.init(chart);
            myChart.clear();
            let sign = [this.$t('Board.Personal.signed'),this.$t('Board.Personal.sign')];
            const option = {
                color: ['#3398DB', 'rgb(151, 222, 252)'],
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    // data: ['已签到', '未签到'],
                    data: sign,
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.charData.map(el => el.date),
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                    },
                ],
                series: [
                    {
                        name: this.$t('Board.Personal.signed'),
                        type: 'bar',
                        barWidth: 20,
                        stack: this.$t('Board.Flow.coach_lesson'),
                        data: this.charData.map(el => el.signedCoachSchedule),
                    },
                    {
                        name: this.$t('Board.Personal.sign'),
                        type: 'bar',
                        stack: this.$t('Board.Flow.coach_lesson'),
                        data: this.charData.map(el => el.unsignedCoachSchedule),
                    },
                ],
            };
            myChart.setOption(option);
        },
        initGroupsChart() {
            const chart = document.getElementById('flow-charts-groups');
            chart.style.height = '500px';
            chart.style.width = '100%';
            const myChart = echarts.init(chart);
            myChart.clear();
            let subscribeArr = [this.$t('Lesson.appoint_count'),this.$t('Stats.Enter.lesson')];
            const option = {
                color: ['#05abef', 'rgb(252, 78, 78)'],
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    // data: ['预约人数', '上课节数'],
                    data: subscribeArr,
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.charData.map(el => el.date),
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        name: this.$t('Lesson.appoint_count'),
                        type: 'line',
                        data: this.charData.map(el => el.teamScheduleClient),
                    },
                    {
                        name: this.$t('Stats.Enter.lesson'),
                        type: 'line',
                        data: this.charData.map(el => el.teamSchedule),
                    },

                ],
            };
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="scss">
.stats-flow {
    .el-select {
        margin-right: .5rem;
    }
    .el-button {
        margin-left: .5rem;
    }
}
.flow-chat-list {
    margin: 20px 0;
    border: 1px solid #f0f0f0;
    padding: 20px 10px;
    overflow: auto;
}
.flow-search {
    color: #666;
    margin: 23px 0;
    line-height: 20px;

    div {
        font-size: 12px;
    }
}
</style>
